import React from "react";
import { Link } from "react-router-dom";
import image3 from "../assets/images/backend.jpg";
import Banner from "../assets/images/banner-webapp.jpg";
import image2 from "../assets/images/frontend.jpg";
import imageReact from "../assets/images/reactjs.png";
import image1 from "../assets/images/techologi.jpg";
import ProjectContentItem from "../components/project-content-item/ProjectContentItem";

const listContentWeb = [
  {
    title: "// Our technologies",
    name: "What Web Application Development Services do you offer?",
    description: (
      <div className="flex flex-col gap-4">
        <div>
          CfiDev specializes in the majority of the web, mobile, and desktop
          technologies, User Exeprience and User Interfaces designs, security,
          business analysis, and QA/QC engineering. We keep in touch with the
          latest trends and changes in technology and adapt ourselves to it.
        </div>
        <div>
          Whatever your app needs, we can handle it. We specialize in web,
          mobile, and desktop technology. We’re ahead of the curve in tech
          trends and always use the best tool for the job. The more tools, the
          better the tool kit.
        </div>
        <div>
          We are exepert in JavaScript,
          <span className="inline font-bold cursor-pointer text-primary">
            React.js
          </span>
          ,{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            Vue.js
          </span>
          ,{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            Angular
          </span>{" "}
          and other{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            front-end technologies
          </span>
          . We also offer backend services with{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            Node.js
          </span>{" "}
          ,{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            Java
          </span>{" "}
          ,{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            PHP
          </span>{" "}
          and{" "}
          <span className="inline font-bold cursor-pointer text-primary">
            Python
          </span>
          .
        </div>
      </div>
    ),
    img: image1,
  },
  {
    title: "// Front-End",
    name: "JavaScript Technologies",
    description: (
      <div className="flex flex-col gap-4">
        <div>
          JavaScript frameworks and libraries are wildly and widely popular.
          They help developers build robust, responsible web apps and can be
          compatible with both desktop and mobile platforms.
        </div>
        <div>
          If you’re unsure of what kind of programming you need, fear not. Our
          project managers and developers will help you make the right call.
        </div>
      </div>
    ),
    bonus: (
      <div
        style={{
          backgroundImage: `url(${imageReact})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          minHeight: "400px",
          paddingTop: "40px",
          marginTop: 20,
        }}
      >
        <h2 className="text-[40px] font-bold py-5 pt-2 text-black md:text-3xl">
          React Development
        </h2>
        <div className="flex flex-col gap-4">
          <div>
            React is another popular JavaScript library that results in robust
            web applications. React renders quickly, is easy to maintain, and
            helps ensure code stability — the latter of which is of course
            important to end users, who just want an app that works.
          </div>
          <div>
            React also has the advantage of being SEO friendly, helping websites
            boost their Google rankings. Rather than just praying to the spirits
            of the internet to increase your web presence, you can rely on React
            to provide some SEO value.
          </div>
        </div>
      </div>
    ),
    img: image2,
  },
  {
    title: "// Back-End",
    img: image3,
    name: "Want to know more about our back-end Technologies?",
    description:
      "Any good piece of software needs rock-solid backend development to give both end users and companies reliable stability and performance. And hey, guess what — we do just that.",
    bonus: (
      <Link
        to="/backend"
        className="block py-5 mt-10 text-xl font-bold transition duration-300 ease-in-out border-2 rounded-lg cursor-pointer min-sm:text-xs sm:text-sm md:p-4 md:mx-auto md:text-base w-fit hover:border-color-hover text-primary px-14 border-primary hover:bg-color-hover hover:text-white whitespace-nowrap"
      >
        Only more about our Backend Technologies
      </Link>
    ),
  },
];

const Web = () => {
  return (
    <div>
      <div
        className="object-cover w-full min-h-[610px] h-full pt-20 pb-10 lg:min-h-full"
        style={{
          backgroundImage: `url(${Banner})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="py-24 px-10 max-w-[1440px] mx-auto">
          <div className="flex w-[80%] flex-col gap-8 text-white md:w-full  lg:mx-auto ">
            <h2 className="text-[60px] md:text-[32px] font-bold md:text-center">
              WEB APP DEVELOPMENT
            </h2>
            <span className="max-w-[850px] text-[18px] md:hidden">
              We can create custom-made web applications, built to last from the
              ground up — so you know your investment is solid. Our developers
              are rock stars when it comes to coding with JavaScript and PHP
              frameworks like ReactJS, Vue.js, Angular, NodeJS, Laravel but also
              Python or java.
            </span>
          </div>
        </div>
      </div>
      <div className="max-w-[1440px] flex flex-col gap-32 md:gap-20 sm:gap-10 py-20 md:py-16 mx-auto xl:w-full px-10 min-sm:px-5">
        {listContentWeb.map((item, index) => (
          <ProjectContentItem item={item} key={index} index={index} />
        ))}
      </div>
    </div>
  );
};

export default Web;
